import { Route, Routes } from "react-router-dom";
import Home from "./Pages/home";
import Camera from "./Pages/camera";
import Form from "./Pages/form";
import Acknoldge from "./Pages/acknoldge";
import Thankyou from "./Pages/thankyou";
// import VideoWithFrame from "./Pages/dummy";
import ChooseFrame from "./Pages/chooseFrame";


export default function Routing() {
    return <>
    <Routes>
    {/* <Route path="/" element={<Home/>}/> */}
    <Route path="/" element={<Acknoldge/>}/>
    <Route path="/form" element={<Form/>}/>
    <Route path="/chooseFrame" element={<ChooseFrame/>}/>
    <Route path="/camera" element={<Camera/>}/>
    <Route path="/thankyou" element={<Thankyou/>}/>
    
    {/* <Route path="/dummy" element={<VideoWithFrame/>}/> */}
  
    </Routes>
    </>
}